<ngx-ui-loader></ngx-ui-loader>
<ngx-ui-loader [loaderId]="'createAccountLoader'" 
               [text]="'Creating your new account. Please wait...'" 
               [textColor]="'#000000'">
</ngx-ui-loader>
<router-outlet></router-outlet>
